module.exports = __webpack_public_path__ + "static/img/novice6.b50df54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/novice6.jpg
// module id = iIh9
// module chunks = 1